import React from 'react';
import { UploadContext } from '../context/upload';
export function RcUploadProvider(props) {
  var children = props.children,
      upload = props.upload;
  return React.createElement(UploadContext.Provider, {
    value: upload
  }, children);
}